import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import styles from './Spinner.module.scss';

const commonSpinnerAttributes = {
  cx: '20',
  cy: '20',
  fill: 'transparent',
  get r() {
    return this.cy - this.strokeWidth / 2;
  },
  strokeWidth: '5'
};

const Spinner = ({
  children,
  className = '',
  color = '#05C3DE',
  showSpinner,
  spinnerConfig = {}
}) => {
  const overlay = useRef(null);
  const [{ height, width }, setDimensions] = useState({ height: 0, width: 0 });
  useEffect(() => {
    let isCurrent = true;
    if (isCurrent && overlay.current) {
      setDimensions(overlay.current.getBoundingClientRect());
    }
    return () => (isCurrent = false);
  }, [showSpinner]);
  return showSpinner ? (
    <div className={styles.overlay} height={height} ref={overlay} width={width}>
      <svg
        className={className}
        height={height}
        viewBox="0 0 40 40"
        width={width}
      >
        <circle
          stroke="#D6D6D5"
          {...spinnerConfig}
          {...commonSpinnerAttributes}
        />
        <circle
          className={styles['loading-spinner']}
          stroke={color}
          strokeDasharray="25, 100"
          {...spinnerConfig}
          {...commonSpinnerAttributes}
        />
      </svg>
    </div>
  ) : (
    children
  );
};

Spinner.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  showSpinner: PropTypes.bool,
  spinnerConfig: PropTypes.object
};

export default Spinner;
